// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"fff89b53","787":"b701888c","992":"93fb58aa"}[chunkId] + ".chunk.js";
};